import a_promise_land from './img/a_promise_land.jpeg'
import alan_turing from './img/alan_turing.jpeg'
import alexander_hamilton from './img/alexander_hamilton.jpeg'
import becoming from './img/becoming.jpeg'
import begin_again from './img/begin_again.jpeg'
import born_a_crime from './img/born_a_crime.jpeg'
import churchill from './img/churchill.jpeg'
import einstein from './img/einstein.jpeg'
import elon_musk from './img/elon_musk.jpeg'
import enriques_journey from './img/enriques_journey.jpeg'
import frida from './img/frida.jpeg'
import ida from './img/ida.jpeg'
import into_the_wild from './img/into_the_wild.jpeg'
import john_adams from './img/john_adams.jpeg'
import mao from './img/mao.jpeg'
import night from './img/night.jpeg'
import shoe_dog from './img/shoe_dog.jpeg'
import spare from './img/spare.jpeg'
import steve_jobs from './img/steve_jobs.jpeg'
import surrender from './img/surrender.jpeg'
import the_power_broker from './img/the_power_broker.jpeg'
import unbroken from './img/unbroken.jpeg'
import vera from './img/vera.jpeg'
import will_in_the_world from './img/will_in_the_world.jpeg'


export const BBookItems = [
  {
    id:1201,
    title:"A Promise Land",
    image: a_promise_land,
    price:1379,
    
  },
  {
    id:1202,
    title:"Alan Turing",
    image: alan_turing,
    price:899,
    
  },
  {
    id:1203,
    title:"Alexander Hamilton",
    image: alexander_hamilton,
    price:399,
    
  },
  {
    id:1204,
    title:"Becoming",
    image: becoming,
    price:699,
    
  },
  {
    id:1205,
    title:"Begin Again",
    image: begin_again,
    price:629,
    
  },
  {
    id:1206,
    title:"Born A Crime",
    image: born_a_crime,
    price:399,
    
  },
  {
    id:1207,
    title:"Churchill",
    image: churchill,
    price:1799,
    
  },
  {
    id:1208,
    title:"Einstein",
    image: einstein,
    price:1729,
    
  },
  {
    id:1209,
    title:"Elon Musk",
    image: elon_musk,
    price:599,
    
  },
  {
    id:1210,
    title:"Enrique's Journey",
    image: enriques_journey,
    price:1299,
    
  },
  {
    id:1211,
    title:"Frida",
    image: frida,
    price:999,
    
  },
  {
    id:1212,
    title:"Ida",
    image: ida,
    price:2999,
    
  },
  {
    id:1213,
    price:899,
    title: "Into The Wild",
    image: into_the_wild,
    
  },
  {
    id:1214,
    price:1699,
    title: "John Adams",
    image: john_adams,
   
  },
  {id:1215,
    price:2359,
    title: "Mao",
    image: mao,
    
  },
  {
    id:1216,
    price:399,
    title: "Night",
    image: night,
    
  },
  {
    id:1217,
    price:299,
    title: "Shoe Dog",
    image: shoe_dog,
    
  },
  {
    id:1218,
    price:799,
    title: "Spare",
    image: spare,
    
  },
  {
    id:1219,
    price:569,
    title: "Steve Jobs",
    image: steve_jobs,
    
  },
  {
    id:1220,
    price:1379,
    title: "Surrender",
    image: surrender,
    
  },
  {
    id:1221,
    price:1299,
    title: "The Power Broker",
    image: the_power_broker,
    
  },
  {
    id:1222,
    price:1599,
    title: "Unbroken",
    image: unbroken,
    
  },
  {
    id:1223,
    price:1699,
    title: "Vera",
    image: vera,
    
  },
  {
    id:1224,
    price:949,
    title: "Will In The World",
    image: will_in_the_world,
    
  },
  
];